import { createComponent } from '@carvana/merch-components';
import { ContentContainer } from '~/components/flp/Financing.styles';

export const Container = createComponent(ContentContainer, {
  className: 'flex max-w-[unset] flex-col gap-6xl md:gap-8xl'
});

export const Divider = createComponent('div', {
  className: 'h-px border border-solid border-border-weak'
});
